import { call, put } from "redux-saga/effects";

import Api from "common/api";
import constants from "./constants";
import moment from "moment";

export default {
  GetRemainingBudgetList: function* (data) {
    const __name = constants.GET_REMAIN_BUDGET_LIST;
    try {
      let lastUpdate = moment().format("D MMM YYYY HH:mm");
      yield put({ type: `FETCH_SUCCESS_${__name}`, list: [], creditCard: false, remainingBudget: 0.0, lastUpdate });
      const res = yield call(Api.getRemainingBudgetList, data.cusId);
      const list = res.data.data;
      if (list.length > 0) {
        const creditCard = list[0].payment_method.includes("credit_card_post_paid");
        const remainingBudget = list[0].RemainingBudget;
        lastUpdate = moment(list[0].datetime).format("D MMM YYYY HH:mm");
        yield put({
          type: `FETCH_SUCCESS_${__name}`,
          list,
          creditCard,
          remainingBudget: creditCard ? "-" : remainingBudget,
          lastUpdate,
        });
      } else {
        yield put({ type: `FETCH_SUCCESS_${__name}`, list: [], creditCard: false, remainingBudget: 0.0, lastUpdate });
      }
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  GetAVGUsage: function* (data) {
    const __name = constants.GET_AVG_USAGE;
    try {
      const res = yield call(Api.getAVGUsage, data.cusId);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  GetPaymentHistory: function* (data) {
    const __name = constants.PAYMENT_HISTORY;
    try {
      const res = yield call(Api.getPaymentHistory, data.cusId, data.accountType);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
};
